var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
import { UIContentWrap } from '@gohighlevel/ghl-ui';
import '@gohighlevel/ghl-ui/dist/style.css';
import { onMounted, provide, ref } from 'vue';
import UpgradeButton from '../components/ConversationsAISettings/components/UpgradeButton.vue';
import { BillingServices } from '../service/BillingService';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AiPricing',
    props: {
        route: Object,
        store: Object,
        router: Object,
        label: String,
        product: String
    },
    emits: ['close'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        // inject current route
        provide('route', props.route);
        provide('store', props.store);
        provide('router', props.router);
        const isFeatureEnable = ref(true);
        const locationConfig = ref();
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            isFeatureEnable.value = yield checkIfFeatureEnable((_b = (_a = props.route) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.location_id);
        }));
        const closeButton = (value) => __awaiter(this, void 0, void 0, function* () {
            emit('close', value);
            console.log('close button clicked', value);
        });
        function checkIfFeatureEnable(entityId) {
            var _a, _b, _c, _d, _e, _f, _g;
            return __awaiter(this, void 0, void 0, function* () {
                if (!entityId)
                    return false;
                const response = yield BillingServices.getByProduct(entityId, 'LOCATION', 'conversationAI', (_b = (_a = props.store) === null || _a === void 0 ? void 0 : _a.getters['locations/getCurrentLocation']) === null || _b === void 0 ? void 0 : _b.company_id, true);
                const data = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.data;
                if (data && ((_d = data[0]) === null || _d === void 0 ? void 0 : _d.config))
                    locationConfig.value = (_e = data[0]) === null || _e === void 0 ? void 0 : _e.config;
                if (data && ((_g = (_f = data[0]) === null || _f === void 0 ? void 0 : _f.config) === null || _g === void 0 ? void 0 : _g.optIn) && data[0].productAvailability)
                    return true;
                return false;
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_unref(UIContentWrap), { style: { "padding": "0 0 0 0 !important" } }, {
                    default: _withCtx(() => [
                        _createCommentVNode(" <PricingComponent :config=\"locationConfig\" /> "),
                        (isFeatureEnable.value)
                            ? (_openBlock(), _createBlock(UpgradeButton, {
                                key: 0,
                                onClose: closeButton,
                                product: __props.product,
                                label: __props.label
                            }, null, 8 /* PROPS */, ["product", "label"]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
